import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({ standalone:false,
  selector: 'app-microsoft-disconnect-dialog',
  templateUrl: './microsoft-disconnect-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./microsoft-disconnect-dialog.component.scss']
})
export class MicrosoftDisconnectDialogComponent {
  title: string= "Title";
  message: string = "Are you sure?";
  confirmButtonText = "Yes";
  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<MicrosoftDisconnectDialogComponent>) {
    if(data){
      this.title=data.title;
      this.message=data.message || this.message;
      if(data.buttonText){
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
      }
    }
   }

   onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}
